/* eslint-disable react/prop-types */
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import React, { useEffect, useState } from 'react'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { useDispatch, useSelector } from 'react-redux'

import {
  fetchTechnicalAbsencesRelatoryInit,
  makeRelatory,
} from '../TechnicalAbsencesRelatoryActions'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import BaseFilter from '../../../components/hooks/BaseFilter'
import Icon from '@mdi/react'
import { mdiMagnify, mdiMagnifyExpand, mdiMicrosoftExcel } from '@mdi/js'
import { InputAdornment } from '@material-ui/core'
import colors from '../../../assets/colors'

export default function Filter(props) {
  const dispatch = useDispatch()
  const { classes } = props
  const [form, setForm] = useState({
    name: '',
    date_start: null,
    date_end: null,
    withTrashed: true,
  })

  const styles = filterStylesComponents()

  const handleSearch = e => {
    e.preventDefault()
    dispatch(fetchTechnicalAbsencesRelatoryInit(null, form, null))
  }

  const handleRelatory = e => {
    e.preventDefault()
    dispatch(makeRelatory(form))
  }

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(fetchTechnicalAbsencesRelatoryInit(null, form, null))
  }

  useEffect(() => {
    if (!form?.name) {
      dispatch(fetchTechnicalAbsencesRelatoryInit(null, form, null))
    }
  }, [form?.name])

  return (
    <BaseFilter>
      <form style={{ width: '100%' }} onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item container spacing={1} xs={8} alignItems='flex-end'>
            <Grid item sm={3} xs={12}>
              <TextField
                onChange={e =>
                  setForm({ ...form, name: e.target.value })
                }
                label="Tecnico"
                className={classes.inputFilter}
                fullWidth
                value={form.name}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleSearch}>
                        <Icon
                          path={mdiMagnifyExpand}
                          size={1}
                          color={colors.graylight}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item sm={3} xs={12}>
              <KeyboardDatePicker
                clearable
                value={form.date_start}
                label="Data Inicial"
                fullWidth
                views={['date']}
                clearLabel="Limpar"
                invalidDateMessage="Data invalida"
                autoOk
                onChange={date => setForm({ ...form, date_start: date })}
                format="dd/MM/yyyy"
              />
            </Grid>

            <Grid item sm={3} xs={12}>
              <KeyboardDatePicker
                clearable
                value={form.date_end}
                label="Data Final"
                fullWidth
                views={['date']}
                clearLabel="Limpar"
                invalidDateMessage="Data invalida"
                autoOk
                onChange={date => setForm({ ...form, date_end: date })}
                format="dd/MM/yyyy"
              />
            </Grid>

            <Grid item sm xs>
              <IconButton
                type="submit"
                className={styles.btnAdd}
                onClick={handleSearch}
              >
                <Icon path={mdiMagnify} size={1} />
                Pesquisar
              </IconButton>
            </Grid>
          </Grid>

          <Grid item sm={4} xs={12} className={styles.areaButtons}>
            <IconButton
              type="button"
              className={styles.btnAdd}
              onClick={handleRelatory}
            >
              <Icon path={mdiMicrosoftExcel} size={1} />
              Download
            </IconButton>
          </Grid>
        </Grid>
      </form>
    </BaseFilter>
  )
}
